import React, { useState, useEffect, useRef } from "react";
import "./Testimonials.css";

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const autoScrollRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      text: "“Teckpik transformed our outdated website into a modern, high-performing platform. Our traffic and engagement increased instantly.”",
      author: "Adeel Khan",
      position: "CEO, NextWave visa agency",
    },
    {
      id: 2,
      text: "“Outstanding web development work! The e-commerce site they built for us handles thousands of orders seamlessly. Highly recommended!”",
      author: "Nasir Iqbal",
      position: "Founder and CEO, RisenStar Goods",
    },
    {
      id: 3,
      text: "“Teckpik designed our complete corporate identity, from logo to social media kits. The aesthetic is clean, modern, and truly world-class. Highly impressed by their graphic design team.”",
      author: "Dr. Ayesha Malik",
      position: "Managing Partner, Malik & Associates",
    },

    {
      id: 5,
      text: "“The web app developed by Teckpik exceeded our expectations. User-friendly, fast, and packed with features our customers love.”",
      author: "David Thompson",
      position: "Manager, Your FitLife",
    },
    {
      id: 6,
      text: "“We needed high-quality product photography for our new online catalog. Teckpik delivered stunning, professional images that elevated our brand presence overnight.”",
      author: "James O'Connell",
      position: "E-commerce Manager, Global Gear",
    },
    {
      id: 7,
      text: "“Teckpik took our complex marketing data and translated it into a clear, effective strategy that dramatically improved our conversion rates. True experts in performance marketing.”",
      author: "Olivia Peterson",
      position: "Digital Strategy Lead, Nordic Solutions",
    },
  ];

  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000); // Change testimonial every 5 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const goToNext = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const goToPrev = () => {
    setCurrentTestimonial(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  return (
    <section id="testimonials" className="testimonials-section ">
      <div className="container pb-5">
        <div className="testimonials-header text-center mb-5">
          <h3 className="testimonials-title fw-bold mb-3">TESTIMONIALS</h3>
          <p className="testimonials-subtitle text-muted">
            What our clients say about our services
          </p>
        </div>

        <div className="testimonials-carousel">
          <div className="carousel-container">
            <button
              className="carousel-btn carousel-btn-prev"
              onClick={goToPrev}
              aria-label="Previous testimonial"
            >
              ‹
            </button>

            <div className="testimonial-card" ref={autoScrollRef}>
              <div className="testimonial-content">
                <div className="quote-icon">“</div>
                <p className="testimonial-text">
                  {testimonials[currentTestimonial].text}
                </p>
                <div className="testimonial-author">
                  <span className="author-name fw-semibold">
                    {testimonials[currentTestimonial].author}
                  </span>
                  <span className="author-position text-muted">
                    {testimonials[currentTestimonial].position}
                  </span>
                </div>
              </div>
            </div>

            <button
              className="carousel-btn carousel-btn-next"
              onClick={goToNext}
              aria-label="Next testimonial"
            >
              ›
            </button>
          </div>

          {/* Dots indicator */}
          <div className="carousel-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${
                  index === currentTestimonial ? "active" : ""
                }`}
                onClick={() => goToTestimonial(index)}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Additional testimonials grid for larger screens */}
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-grid-item ${
                index === currentTestimonial ? "active" : ""
              }`}
              onClick={() => goToTestimonial(index)}
            >
              <p className="testimonial-grid-text">{testimonial.text}</p>
              <div className="testimonial-grid-author">
                <span className="fw-semibold">{testimonial.author}</span>
                <span className="text-muted small">{testimonial.position}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
